export const navigation = [
  {
    text: 'Home',
    path: '/home',
    icon: 'home'
  },
  {
    text: 'Register Provider',
    path: 'pages/registration',
    icon: 'card'
  },
  {
    text: 'Manage Providers',
    path: 'pages/edit',
    icon: 'edit'
  },
  {
    text: 'Registration Requests',
    path: 'pages/manage',
    icon: 'columnchooser'
  },
  {
    text: 'User Management',
    path: 'pages/users',
    icon: 'group'
  },
  {
    text: 'User Management',
    path: 'pages/dohusers',
    icon: 'group'
  },
  {
    text: 'Code Setup',
    path: 'pages/codesetup',
    icon: 'info'
  },
  {
    text: 'Settings',
    path: 'pages/settings/settings',
    icon: 'preferences'
  },
  {
    text: 'Financial Settings',
    path: 'pages/settings/financial',
    icon: 'money'
  },
  {
    text: 'E-Claims',
    path: 'clemittance-link',
    icon: 'link'
  },
  {
    text: 'How To',
    path: 'portal-download',
    icon: 'download'
  }
];

export const providerUser = [
  {
    text: 'Home',
    path: '/home',
    icon: 'home'
  },
  {
    text: 'E-Claims',
    path: 'clemittance-link',
    icon: 'link'
  },
  {
    text: 'How To',
    path: 'portal-download',
    icon: 'download'
  }
];

export const providerAdmin = [
  {
    text: 'Home',
    path: '/home',
    icon: 'home'
  },
  {
    text: 'Code Setup',
    path: 'pages/codesetup',
    icon: 'upload'
  },
  {
    text: 'User Management',
    path: 'pages/users',
    icon: 'group'
  },
  {
    text: 'Provider Info',
    path: 'pages/info',
    icon: 'info'
  },
  {
    text: 'Settings',
    path: 'pages/settings/settings',
    icon: 'preferences'
  },
  {
    text: 'E-Claims',
    path: 'clemittance-link',
    icon: 'link'
  },
  {
    text: 'How To',
    path: 'portal-download',
    icon: 'download'
  }
];

export const dOHAdmin = [
  {
    text: 'Home',
    path: '/home',
    icon: 'home'
  },
  {
    text: 'Registration Requests',
    path: 'pages/manage',
    icon: 'columnchooser'
  },
  {
    text: 'Manage Providers',
    path: 'pages/edit',
    icon: 'edit'
  },
  {
    text: 'User Management',
    path: 'pages/dohusers',
    icon: 'group'
  },
  {
    text: 'Financial Settings',
    path: 'pages/settings/financial',
    icon: 'money'
  },
  {
    text: 'E-Claims',
    path: 'clemittance-link',
    icon: 'link'
  },
  {
    text: 'How To',
    path: 'portal-download',
    icon: 'download'
  }
];

export const dOHAccountant = [
  {
    text: 'Home',
    path: '/home',
    icon: 'home'
  },
  {
    text: 'E-Claims',
    path: 'clemittance-link',
    icon: 'link'
  },
  {
    text: 'How To',
    path: 'portal-download',
    icon: 'download'
  }
];

export const dOHClaims = [
  {
    text: 'Home',
    path: '/home',
    icon: 'home'
  },
  {
    text: 'E-Claims',
    path: 'clemittance-link',
    icon: 'link'
  },
  {
    text: 'How To',
    path: 'portal-download',
    icon: 'download'
  }
];

export const adjudicatorAdmin = [
  {
    text: 'Home',
    path: '/home',
    icon: 'home'
  },
  {
    text: 'E-Claims',
    path: 'clemittance-link',
    icon: 'link'
  },
  {
    text: 'How To',
    path: 'portal-download',
    icon: 'download'
  }
];

export const adjudicatorUser = [
  {
    text: 'Home',
    path: '/home',
    icon: 'home'
  },
  {
    text: 'E-Claims',
    path: 'clemittance-link',
    icon: 'link'
  },
  {
    text: 'How To',
    path: 'portal-download',
    icon: 'download'
  }
];

export const manteqAdmin = [
  {
    text: 'Home',
    path: '/home',
    icon: 'home'
  },
  {
    text: 'Registration Requests',
    path: 'pages/manage',
    icon: 'columnchooser'
  },
  {
    text: 'Manage Providers',
    path: 'pages/edit',
    icon: 'edit'
  },
  {
    text: 'User Management',
    path: 'pages/adminusers',
    icon: 'group'
  },
  {
    text: 'Financial Settings',
    path: 'pages/settings/financial',
    icon: 'money'
  },
  {
    text: 'E-Claims',
    path: 'clemittance-link',
    icon: 'link'
  },
  {
    text: 'How To',
    path: 'portal-download',
    icon: 'download'
  }
];
